import { CombinedGraphQLErrors } from '@apollo/client/errors';

/**
 * Reads the GraphQL errors carried by an Apollo error.
 *
 * Apollo Client v4 removed `error.graphQLErrors`. Errors returned in the
 * `errors` field of a GraphQL response now arrive wrapped in a
 * `CombinedGraphQLErrors`, and everything else (network failures, parse
 * errors, link errors) is a plain error with no GraphQL errors at all.
 *
 * @param {unknown} error - error from a hook result or a rejected mutate/query promise
 * @returns {Array<{message: string, path?: Array, extensions?: Object}>} empty when the error carries none
 */
export const getGraphQLErrors = (error) => (CombinedGraphQLErrors.is(error) ? [...error.errors] : []);

/**
 * Builds a message to show the user from an Apollo error.
 *
 * Falls back to the error's own `message` when it carries no GraphQL errors so
 * that network failures still surface something instead of an empty string.
 *
 * @param {unknown} error - error from a hook result or a rejected mutate/query promise
 * @param {string} [separator=' '] - joins the messages when the server returned several
 * @returns {string} empty string when there is no error
 */
export const getGraphQLErrorMessage = (error, separator = ' ') => {
    const errors = getGraphQLErrors(error);

    if (errors.length) {
        return errors.map((e) => e.message).join(separator);
    }

    return error?.message || '';
};
